import { useController } from 'react-hook-form';
import { TextArea } from 'ui/inputs';
import type { TextAreaProps } from 'ui/inputs/textArea/TextArea.types';
import { FieldProps } from './types';

type TextAreaFieldProps = FieldProps &
  Omit<TextAreaProps, 'onChange' | 'onBlur' | 'value' | 'hasError'>;

export const TextAreaField = ({ name, defaultValue, control, ...rest }: TextAreaFieldProps) => {
  const {
    field: { onChange, onBlur, value },
    fieldState: { error },
  } = useController({
    control,
    name,
    defaultValue,
  });

  return (
    <TextArea {...rest} value={value} onBlur={onBlur} onChange={onChange} hasError={!!error} />
  );
};
